import { ProcessDeUtil } from '../../../domain/process-de-util';

export const workFlowActions: any[] = [
    { text: '正向', value: 'Forward' },
    { text: '反向', value: 'Backward' },
    { text: '终止', value: 'Abort' }
];
export const executionTime = [
    { text: '流转前', value: 'Pre' },
    { text: '流转后', value: 'Post' }
];

export class FormMethodConfig {
    constructor() {
        this.id = ProcessDeUtil.createNM();
        this.workFlowAction = workFlowActions[0].value;
        this.executionTime = executionTime[0].value;
        this.sortOrder = 1;
    }
    id: string;
    formFormatConfigId: string;
    workFlowAction: string;
    method: string;
    executionTime: string;
    sortOrder: number;
    methodParameters: Array<any>;
}


